/**
 * Client side JS for remote support
 *
 * This file checks for a meta-tag in the header of the page that says the system should try to connect to the remote support client
 * If the meta-tag is present, it will try to connect
 * If it connects, ask the user if they want to allow the connection
 * If they do, allow the connection
 * If they don't, disconnect, and also reset the setting in the database - for the could have been a malicious connection
 *
 * If the connection was accepted, store the fact that the connection was accepted in a cookie
 * Whenever the page is loaded, check for the cookie
 * If the cookie is present, don't ask the user to connect again
 * If it is, show a button to allow the user to disconnect
 * If it isn't, delete the cookie
 *
 * If the user clicks the disconnect button, disconnect from the remote support client, and delete the cookie
 * Also reset the setting in the database.
 *
 * Whenever a connection is active, show a green tick sign on the lower right corner of the screen
 *
 * This file would provide a RemoteSupport-Object that can be used to connect to the remote support client.
 * Todo: Setup a realtime connection to view the user's screen and be able to control it
 * For now this feature would be able to send (Log) messages to the remote support client
 *
 * ---- TECHNICAL INFO ----
 * This system uses PeerJs to connect to the remote support client
 * Therefore when it should try to connect, it should add the CDN to the header of the page (https://unpkg.com/peerjs@1.5.2/dist/peerjs.min.js)
 * Both the client peer id  and the remote support client peer id are in the remote-support meta-tag, separated by a comma
 */


jQuery(document).ready(function($) {
    if (window.location.pathname === '/remote-support') {
        return;
    }
    // Check if the meta-tag is present
    const remoteSupportMetaTag = $('meta[name="remote-support"]');
    if (remoteSupportMetaTag.length > 0) {
        (async () => {

            await remoteSupport.setupPeerJs();
            // Get the meta-tag content
            let metaTagContent = remoteSupportMetaTag.attr('content');

            // Split the content by comma
            let metaTagContentSplit = metaTagContent.split(',');
            // Get the client peer id
            let clientPeerId = metaTagContentSplit[0];
            // Get the remote support client peer id
            let remoteSupportClientPeerId = metaTagContentSplit[1];

            remoteSupportClient.initiateConnection(clientPeerId, remoteSupportClientPeerId);
        })();

    }
});

class RemoteSupportClient {
    constructor() {
        // noop
    }

    get connectionWasActive() {
        const previousPeer = getCookie('remote-support-peer');
        return previousPeer && getCookie('remote-support-active') === 'true';
    }

    initiateConnection(clientPeerId: string, remoteSupportClientPeerId: string) {
        // Create a new peer
        this.peer = new window.peerjs.Peer(clientPeerId);

        // console.log({ peer: this.peer });


        this.peer.on('open', (id) => {
            // console.log('My peer ID is: ' + id);

            const previousPeer = getCookie('remote-support-peer');

            // console.log('previous peer', previousPeer);
            // console.log('connection was active', this.connectionWasActive);

            if (this.connectionWasActive) {
                // try to connect to the previous peer again to restore the connection
                // console.log('reconnecting to previous peer', previousPeer);
                this.connect(this.peer.connect(previousPeer));
            }

            this.peer.on('connection', (conn) => {
                if (conn.peer !== remoteSupportClientPeerId) {
                    return;
                }
                setCookie('remote-support-peer', conn.peer, 1);
                // console.log('got connection', conn);

                this.connect(conn);
            });


        })
    }

    connect(conn) {
        const $ = jQuery.noConflict();
        this.connection = conn;
        // When the connection is open
        this.connection.on('open', async () => {
            // console.log('Connection open');
            // console.log('active', this.connectionWasActive);

            const onAccept = () => {
                // Send a message to the remote support client
                this.send('connect');
                // Store the acceptance of the connection in a cookie
                setCookie('remote-support-active', 'true', 1);
                // Show a green tick sign on the lower right corner of the screen
                $('body').append('<div class="remote-support-connection-active" style="position: fixed; bottom: 5px; right: 5px; color: rgb(22, 139, 186); width: 40px; height: 40px; border-radius: 50%; border: solid 1px rgb(22, 139, 186); z-index: 1000000; background: white; text-align: center; line-height: 40px; font-size: 15px;">&#10004;</div>');

                $('.remote-support-connection-active').click(async () => {
                    // Ask the user if they want to disconnect
                    let disconnect = await asyncConfirm('Wilt u de live verbinding met de helpdesk verbreken?');
                    // If they do
                    if (disconnect) {
                        // Send a message to the remote support client
                        this.send('disconnect');
                        // Disconnect from the remote support client
                        this.connection.close();
                    }
                });
            }

            // If the cookie is present
            if (this.connectionWasActive) {
                onAccept();
            } else {
                // Ask the user if they want to connect
                let connect = await asyncConfirm('Wilt u een live verbinding met de helpdesk starten?');
                // If they do
                if (connect) {
                    onAccept();
                } else {
                    // Send a message to the remote support client
                    this.send('deny');
                    // Disconnect from the remote support client
                    this.connection.close();
                }
            }
        });
        // When the connection is closed
        this.connection.on('close', ()=> {
            // console.log('Connection closed');
            this.resetSetting();
        });
    }

    resetSetting() {
        const $ = jQuery.noConflict();

        // Delete the cookies
        deleteCookie('remote-support-active');
        deleteCookie('remote-support-peer');

        // Remove the green tick sign
        $('.remote-support-connection-active').remove();
        // Reset the setting in the database
        // $.ajax({
        //     url: '/remote-support/reset-setting',
        //     method: 'POST',
        //     data: {
        //         _token: $('meta[name="csrf-token"]').attr('content'),
        //         type: 'digitalPresence',
        //     }
        // });
    }

    sendMessageToSupport(message: string) {
        this.send('message', message);
    }

    sendErrorLogToSupport(errorLog: any) {
        this.send('error', errorLog);
    }

    sendLogToSupport(log: any) {
        this.send('log', log);
    }

    send(type, message = true) {
        if (!this.connection || !this.connection.open) {
            return;
        }
        this.connection.send(JSON.stringify({ type: type, data: message, timestamp: new Date().toISOString() }));
    }
}
const remoteSupportClient = new RemoteSupportClient();